import React from 'react';
import { useLang } from '../../i18n/LangContext';
import { BRAND } from '../../data/siteData';
import { Siren, Clock, Phone, MessageCircle, ArrowRight, Zap, Droplet, Wind } from 'lucide-react';

const waNumber = '1' + (BRAND.phone || '').replace(/\D/g, '');

export default function EmergencySection() {
  const { t } = useLang();
  const e = t.emergency;

  return (
    <section id="emergency" className="relative bg-[#0B0D0F] py-20 sm:py-28 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-[#E11D2A]/10 blur-3xl" />
        <div className="absolute -bottom-24 -right-24 w-96 h-96 rounded-full bg-[#E11D2A]/5 blur-3xl" />
      </div>

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="rounded-2xl border border-[#E11D2A]/25 bg-gradient-to-br from-[#14090A] to-[#12151A] p-8 sm:p-12 lg:p-14">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div>
              <div className="inline-flex items-center gap-2 rounded-full border border-[#E11D2A]/40 bg-[#E11D2A]/10 px-4 py-1.5 mb-6">
                <span className="relative flex h-2 w-2">
                  <span className="absolute inline-flex h-full w-full rounded-full bg-[#E11D2A] opacity-75 animate-ping" />
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-[#E11D2A]" />
                </span>
                <span className="text-[#FF6B73] text-xs font-mono tracking-[0.2em] uppercase">{e.badge}</span>
              </div>

              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white font-outfit flex items-center gap-3">
                <Siren className="w-8 h-8 sm:w-9 sm:h-9 text-[#E11D2A]" />
                {e.heading}
              </h2>
              <p className="text-xl text-white font-semibold mt-4">{e.needHelp}</p>
              <p className="text-slate-300 mt-3 leading-relaxed">{e.intro}</p>

              <div className="flex items-center gap-2 mt-5 text-[#FF6B73]">
                <Clock className="w-4 h-4" />
                <span className="text-sm font-semibold">{e.maxResponse}</span>
              </div>

              <div className="flex flex-wrap gap-4 mt-6 text-slate-400 text-sm">
                <span className="flex items-center gap-1.5"><Zap className="w-4 h-4 text-[#D4AF37]" /> Electrical</span>
                <span className="flex items-center gap-1.5"><Droplet className="w-4 h-4 text-[#D4AF37]" /> Plumbing</span>
                <span className="flex items-center gap-1.5"><Wind className="w-4 h-4 text-[#D4AF37]" /> HVAC</span>
              </div>
            </div>

            <div className="flex flex-col gap-3">
              <a href="/emergency-services" data-testid="emergency-request-cta"
                className="group flex items-center justify-center gap-3 bg-[#E11D2A] hover:bg-[#C41623] text-white font-bold py-4 px-6 rounded-lg text-base transition-all">
                <Siren className="w-5 h-5" />{e.requestBtn}
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </a>
              <div className="grid grid-cols-2 gap-3">
                <a href={`tel:${BRAND.phone}`} data-testid="emergency-call-cta"
                  className="flex items-center justify-center gap-2 border border-white/15 hover:border-white/30 bg-white/5 text-white font-semibold py-3.5 px-4 rounded-lg text-sm transition-all">
                  <Phone className="w-4 h-4" />{e.callBtn}
                </a>
                <a href={`https://wa.me/${waNumber}`} target="_blank" rel="noopener noreferrer" data-testid="emergency-whatsapp-cta"
                  className="flex items-center justify-center gap-2 border border-white/15 hover:border-white/30 bg-white/5 text-white font-semibold py-3.5 px-4 rounded-lg text-sm transition-all">
                  <MessageCircle className="w-4 h-4" />{e.whatsappBtn}
                </a>
              </div>
              <p className="text-slate-500 text-xs text-center mt-1">{e.supporting}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
